import BaseComponent from 'scripts/BaseComponent.js';
import UnderlayHelper from '../../global/underlay-helper';
import { AccessibilityHelper } from '../../../scripts/accessibility/accessibilityHelper';

export default class MiniCart extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      drawerToggleBtn: '.js-toggleMiniCart',
    };

    this.dom = {
      $component: component,
      $drawerToggleBtns: document.querySelectorAll(this.refs.drawerToggleBtn),
    };

    this.state = {
      drawerOpen: false,
      drawerOpenClass: 'open-cart-drawer',
      underlayHelper: new UnderlayHelper({ overNav: true }),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      openCartDrawerEvent: 'opencartdrawer',

    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setClick(Array.from(dom.$drawerToggleBtns), this.toggleDrawer);
    this.setOnCustomEvent(state.openCartDrawerEvent, this.openDrawer);
    state.underlayHelper.addClickListener(this.closeDrawer.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
  }

  toggleDrawer() {
    const { state } = this;

    if (state.drawerOpen) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  openDrawer() {
    const { dom, state } = this;

    dom.$component.classList.add(state.drawerOpenClass);
    dom.$component.setAttribute('aria-hidden', 'false');
    dom.$component.setAttribute('aria-expanded', 'true');
    state.underlayHelper.open();
    state.focusTrap.set();
    state.drawerOpen = true;
  }

  closeDrawer() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.drawerOpenClass);
    dom.$component.setAttribute('aria-hidden', 'true');
    dom.$component.setAttribute('aria-expanded', 'false');
    state.underlayHelper.close();
    state.focusTrap.unset();
    state.drawerOpen = false;
  }
}
